//#region ENUM IconsEnum
export enum IconsEnum {
  account = 'account',
  accountCog = 'accountCog',
  accountCogOutline = 'accountCogOutline',
  accountEdit = 'accountEdit',
  accountEditOutline = 'accountEditOutline',
  accountMinus = 'accountMinus',
  accountMinusOutline = 'accountMinusOutline',
  accountOutline = 'accountOutline',
  accountPlus = 'accountPlus',
  accountPlusOutline = 'accountPlusOutline',
  accountRemove = 'accountRemove',
  accountRemoveOutline = 'accountRemoveOutline',
  alertBox = 'alertBox',
  alertBoxOutline = 'alertBoxOutline',
  alertRhombus = 'alertRhombus',
  alertRhombusOutline = 'alertRhombusOutline',
  alignHorizontalCenter = 'alignHorizontalCenter',
  alignVerticalCenter = 'alignVerticalCenter',
  alpha = 'alpha',
  applicationCog = 'applicationCog',
  applicationCogOutline = 'applicationCogOutline',
  archiveMarker = 'archiveMarker',
  archiveMarkerOutline = 'archiveMarkerOutline',
  arrowDown = 'arrowDown',
  arrowLeft = 'arrowLeft',
  arrowRight = 'arrowRight',
  arrowUp = 'arrowUp',
  backSpaceOutline = 'backSpaceOutline',
  bandage = 'bandage',
  barcode = 'barcode',
  barcodeOff = 'barcodeOff',
  barcodeScan = 'barcodeScan',
  bellOffOutline = 'bellOffOutline',
  bellOutline = 'bellOutline',
  beta = 'beta',
  biohazard = 'biohazard',
  bookSettings = 'bookSettings',
  bookSettingsOutline = 'bookSettingsOutline',
  bug = 'bug',
  bugOutline = 'bugOutline',
  cBoxOutline = 'cBoxOutline',
  calculator = 'calculator',
  calendar = 'calendar',
  calendarClear = 'calendarClear',
  calendarMultiSelect = 'calendarMultiSelect',
  calendarMultiSelectOutline = 'calendarMultiSelectOutline',
  camera = 'camera',
  cameraLock = 'cameraLock',
  cameraLockOpen = 'cameraLockOpen',
  cameraLockOpenOutline = 'cameraLockOpenOutline',
  cameraLockOutline = 'cameraLockOutline',
  cameraOff = 'cameraOff',
  cameraOffOutline = 'cameraOffOutline',
  cameraOutline = 'cameraOutline',
  cancel = 'cancel',
  cart = 'cart',
  cartFilled = 'cartFilled',
  cartOutline = 'cartOutline',
  cartVariant = 'cartVariant',
  cash = 'cash',
  cashCheck = 'cashCheck',
  cashClock = 'cashClock',
  cashEdit = 'cashEdit',
  cashFast = 'cashFast',
  cashLock = 'cashLock',
  cashLockOpen = 'cashLockOpen',
  cashMarker = 'cashMarker',
  cashMinus = 'cashMinus',
  cashMultiple = 'cashMultiple',
  cashOff = 'cashOff',
  cashPlus = 'cashPlus',
  cashRefund = 'cashRefund',
  cashRegister = 'cashRegister',
  cashRemove = 'cashRemove',
  cashSync = 'cashSync',
  chat = 'chat',
  chatOutline = 'chatOutline',
  checkAll = 'checkAll',
  checkBold = 'checkBold',
  checkCircle = 'checkCircle',
  checkCircleOutline = 'checkCircleOutline',
  checkOutline = 'checkOutline',
  checkUnderline = 'checkUnderline',
  checkUnderlineCircle = 'checkUnderlineCircle',
  checkUnderlineCircleOutline = 'checkUnderlineCircleOutline',
  chemicalWeapon = 'chemicalWeapon',
  chevronDown = 'chevronDown',
  chevronLeft = 'chevronLeft',
  chevronLeftCircleOutline = 'chevronLeftCircleOutline',
  chevronRight = 'chevronRight',
  chevronRightCircleOutline = 'chevronRightCircleOutline',
  chevronUp = 'chevronUp',
  clipboard = 'clipboard',
  clipboardCheckOutline = 'clipboardCheckOutline',
  clock = 'clock',
  close = 'close',
  closeBox = 'closeBox',
  closeBoxOutline = 'closeBoxOutline',
  closeCircle = 'closeCircle',
  closeCircleOutline = 'closeCircleOutline',
  closeOctagon = 'closeOctagon',
  closeOctagonOutline = 'closeOctagonOutline',
  closeOutline = 'closeOutline',
  closeThick = 'closeThick',
  cog = 'cog',
  cogBox = 'cogBox',
  cogOutline = 'cogOutline',
  contentCopy = 'contentCopy',
  contentSave = 'contentSave',
  contentSaveOutline = 'contentSaveOutline',
  create = 'create',
  customSortUpDown = 'customSortUpDown',
  delta = 'delta',
  delete = 'delete',
  deleteClock = 'deleteClock',
  deleteClockOutline = 'deleteClockOutline',
  deleteEmpty = 'deleteEmpty',
  deleteEmptyOutline = 'deleteEmptyOutline',
  deleteForever = 'deleteForever',
  deleteForeverOutline = 'deleteForeverOutline',
  deleteOutline = 'deleteOutline',
  deleteSweep = 'deleteSweep',
  deleteSweepOutline = 'deleteSweepOutline',
  devTo = 'devTo',
  dotsVertical = 'dotsVertical',
  download = 'download',
  downloadOutline = 'downloadOutline',
  emailAlertOutline = 'emailAlertOutline',
  emailCheckOutline = 'emailCheckOutline',
  emailFastOutline = 'emailFastOutline',
  emailPlus = 'emailPlus',
  emailPlusOutline = 'emailPlusOutline',
  emailRemove = 'emailRemove',
  emailRemoveOutline = 'emailRemoveOutline',
  emailSyncOutline = 'emailSyncOutline',
  emailVariant = 'emailVariant',
  epsilon = 'epsilon',
  eyeOffOutline = 'eyeOffOutline',
  eyeOutline = 'eyeOutline',
  fileCog = 'fileCog',
  fileCogOutline = 'fileCogOutline',
  fileTrayStacked = 'fileTrayStacked',
  filterCogOutline = 'filterCogOutline',
  filterVariant = 'filterVariant',
  filterVariantMinus = 'filterVariantMinus',
  filterVariantPlus = 'filterVariantPlus',
  filterVariantRemove = 'filterVariantRemove',
  flagOutline = 'flagOutline',
  flashlight = 'flashlight',
  flashlightOff = 'flashlightOff',
  folder = 'folder',
  folderAlert = 'folderAlert',
  formatAlignCenter = 'formatAlignCenter',
  formatAlignLeft = 'formatAlignLeft',
  formatAlignRight = 'formatAlignRight',
  formatBold = 'formatBold',
  formatItalic = 'formatItalic',
  fullScreen = 'fullScreen',
  fullScreenExit = 'fullScreenExit',
  gamma = 'gamma',
  googleDinosaur = 'googleDinosaur',
  helpCircleOutline = 'helpCircleOutline',
  home = 'home',
  infoSlabCircleOutline = 'infoSlabCircleOutline',
  key = 'key',
  linkVariant = 'linkVariant',
  lockClosedOutline = 'lockClosedOutline',
  lockOpenOutline = 'lockOpenOutline',
  logIn = 'logIn',
  logoFull = 'logoFull',
  logoG = 'logoG',
  logoIQ = 'logoIQ',
  magnify = 'magnify',
  magnifyMinus = 'magnifyMinus',
  magnifyPlus = 'magnifyPlus',
  magnifyRemove = 'magnifyRemove',
  mail = 'mail',
  menu = 'menu',
  messageAlert = 'messageAlert',
  messageAlertOutline = 'messageAlertOutline',
  moonWaningCrescent = 'moonWaningCrescent',
  newBox = 'newBox',
  notEqualVariant = 'notEqualVariant',
  openInNew = 'openInNew',
  pageFirst = 'pageFirst',
  pageLast = 'pageLast',
  pause = 'pause',
  pauseBox = 'pauseBox',
  pauseBoxOutline = 'pauseBoxOutline',
  pdfBox = 'pdfBox',
  pencil = 'pencil',
  pencilOff = 'pencilOff',
  person = 'person',
  personMinusOutline = 'personMinusOutline',
  personMultipleMinusOutline = 'personMultipleMinusOutline',
  personMultiplePlusOutline = 'personMultiplePlusOutline',
  personOffOutline = 'personOffOutline',
  personPlusOutline = 'personPlusOutline',
  pieChart = 'pieChart',
  pint = 'pint',
  planet = 'planet',
  play = 'play',
  playBox = 'playBox',
  playBoxOutline = 'playBoxOutline',
  playlistPlus = 'playlistPlus',
  plus = 'plus',
  progressClock = 'progressClock',
  progressPencil = 'progressPencil',
  priceTags = 'priceTags',
  printerOutline = 'printerOutline',
  radioBoxBlank = 'radioBoxBlank',
  radioBoxMarked = 'radioBoxMarked',
  receiptOutline = 'receiptOutline',
  receiptTextCheckOutline = 'receiptTextCheckOutline',
  receiptTextEditOutline = 'receiptTextEditOutline',
  receiptTextOutline = 'receiptTextOutline',
  receiptTextRemoveOutline = 'receiptTextRemoveOutline',
  receiptTextSendOutline = 'receiptTextSendOutline',
  rotateOrbit = 'rotateOrbit',
  security = 'security',
  settings = 'settings',
  shieldAirplane = 'shieldAirplane',
  shieldAirplaneOutline = 'shieldAirplaneOutline',
  shopping = 'shopping',
  shoppingOutline = 'shoppingOutline',
  skullScan = 'skullScan',
  skullScanOutline = 'skullScanOutline',
  sort = 'sort',
  store = 'store',
  storeMultiple = 'storeMultiple',
  storeEdit = 'storeEdit',
  storeEditOutline = 'storeEditOutline',
  storeOutline = 'storeOutline',
  storeRemove = 'storeRemove',
  stylingSvg = 'stylingSvg',
  stylingSvgLogin = 'stylingSvgLogin',
  sync = 'sync',
  swapVertical = 'swapVertical',
  tableCog = 'tableCog',
  tagMultiple = 'tagMultiple',
  tagMultipleOutline = 'tagMultipleOutline',
  terminal = 'terminal',
  timerSand = 'timerSand',
  today = 'today',
  tune = 'tune',
  tuneVariant = 'tuneVariant',
  tuneVertical = 'tuneVertical',
  tuneVerticalVariant = 'tuneVerticalVariant',
  undo = 'undo',
  undoOutline = 'undoOutline',
  whiteBalanceSunny = 'whiteBalanceSunny',
}

//#endregion

